module.exports = __webpack_public_path__ + "img/BAU Seniors_27.bf79b567.jpg";